
import React from "react";
import { useSelector } from "react-redux";
import NotFound from "../../../../../components/NotFound";
import { storeSelector } from "../../../../../redux/slices/storeSlice";
import StoreDataTable from "../components/StoreDataTable";

export default function ConnectedStores() {
  const { userRecords, isLoading } = useSelector(storeSelector);
  return (
    <div style={{padding:"15px"}}>

      <div>
        <div
          style={{
            // paddingBottom: "20px",
            width: "100%",
            boxShadow:
              " 0px 2px 2px rgb(145 158 171 / 20%), 0px 12px 24px -4px rgb(145 158 171 / 12%)",
          }}
        >
          {!isLoading && <StoreDataTable stores={userRecords?.user} />}
          <div style={{ paddingBottom: "40px" }}>
            {(userRecords?.user?.length < 1 || isLoading) && (
              <NotFound loading={isLoading} margin="5%" content="records" subContent="do not have any user record" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
